import { JoinStateEnum } from "@/__generated__/types";

export const JoinStateGroups = {
  inquired: [
    JoinStateEnum.PreInquired,
    JoinStateEnum.Inquired,
    JoinStateEnum.DateOfInitialContactMissing,
    JoinStateEnum.Null,
  ],
  applied: [JoinStateEnum.Applied, JoinStateEnum.AppComplete],
  admitted: [JoinStateEnum.Accepted],
  committed: [JoinStateEnum.Committed],
};

export type JoinStateGroupNames = keyof typeof JoinStateGroups;

export const getJoinStateGroupNames = () =>
  Object.keys(JoinStateGroups) as JoinStateGroupNames[];
